import { Button, Typography } from "@mui/material";
import PrimaryButtonModel from "src/app/models/components/primaryButton.model";
import styles from "src/app/styles/components/primaryButton.component.style";

const PrimaryButtonComponentView: React.FC<PrimaryButtonModel> = (
  primaryButtonProps: PrimaryButtonModel,
) => {
  const { text, sx, loading, onClick, fullWidth } = primaryButtonProps;
  return (
    <Button
      sx={[sx ?? {}, styles.button]}
      fullWidth={fullWidth}
      loading={loading}
      onClick={onClick}
    >
      <Typography textTransform="math-auto" sx={styles.text}>
        {text}
      </Typography>
    </Button>
  );
};

export default PrimaryButtonComponentView;
